import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { UserContext } from "./UserContext";
import Dashboard from "./Dashboard";
import Login from "./Login";
import SignUp from "./SignUp";
import ListViewer from "./ListViewer";
import Home from "./Home";

function App() {
  const { currentUser } = useContext(UserContext);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/dashboard"
          element={currentUser ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route
          path="/login"
          element={!currentUser ? <Login /> : <Navigate to="/dashboard" />}
        />
        <Route
          path="/signup"
          element={!currentUser ? <SignUp /> : <Navigate to="/dashboard" />}
        />
        <Route
          path="/list/:listId"
          element={currentUser ? <ListViewer /> : <Navigate to="/login" />}
        />
        <Route
          path="/"
          element={<Navigate to={currentUser ? "/dashboard" : "/login"} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
